import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useOrderUnreadMessages } from '@/shared/hooks/useOrderUnreadMessages';

interface OrderChatBadgeProps {
  orderId: string;
  customerId: string;
}

/**
 * Badge affichant les messages non lus pour une commande
 */
export const OrderChatBadge: React.FC<OrderChatBadgeProps> = ({ orderId, customerId }) => {
  const { unreadCount, hasActiveChat } = useOrderUnreadMessages(orderId, customerId);

  if (!hasActiveChat) return null;

  return (
    <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium">
      <MessageCircle className="h-3.5 w-3.5" />
      <span>Discussion</span>
      {unreadCount > 0 && (
        <span className="px-1.5 py-0.5 bg-error text-white rounded-full text-[10px] font-bold min-w-[18px] text-center">
          {unreadCount}
        </span>
      )}
    </div>
  );
};

